import CommonFormItem from 'common/components/formItem'

import { InputElement } from '../../interface'

import { getFieldError } from './helpers'
import { FormInstance } from './interfaces'

type Props = {
  field: InputElement
  form: FormInstance
  className?: string
  children?: React.ReactNode
}

const FormItem: React.FC<Props> = ({ field, form, className, children }) => {
  const fieldError = getFieldError(form, field.field_id)
  const errorMsg = fieldError
    ? Array.isArray(fieldError)
      ? fieldError[0]
      : (fieldError as any)
    : undefined

  return (
    <CommonFormItem
      label={field.title}
      error={errorMsg}
      data-testid={field.field_id}
      className={className}
    >
      {children}
    </CommonFormItem>
  )
}

export default FormItem
